/**
 * المرحلة 1.4 — the visit's papers, fetched and printed.
 *
 * Each print is the server's answer (the letterhead, the signature, the
 * verify code and its QR) built into a self-contained page by
 * domain/visitReportPrint.js and sent through the offscreen frame
 * (services/printPrescription.js printVisitPaper), whose dialog also saves a PDF.
 */

import { encounterApi } from '../../api/endpoints';
import { buildCertificateHtml, buildReferralHtml, buildVisitReportHtml } from '../../domain/visitReportPrint';
import { printVisitPaper } from '../../services/printPrescription';

export async function printVisitReport(encounterId, { t, lang }) {
  const { report } = await encounterApi.report(encounterId);
  return printVisitPaper(buildVisitReportHtml, { report, t, lang });
}

export async function printCertificate(certificateId, { t, lang }) {
  const print = await encounterApi.certificate(certificateId);
  return printVisitPaper(buildCertificateHtml, { print, t, lang });
}

export async function printReferral(referralId, { t, lang }) {
  const print = await encounterApi.referral(referralId);
  return printVisitPaper(buildReferralHtml, { print, t, lang });
}
